var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.value)?_c('i',{staticClass:"fa fa-check",staticStyle:{"font-size":"22px"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }